(() => {
  const root = document.documentElement;
  const drawer = document.querySelector("[data-vl-cart-drawer]");
  const overlay = document.querySelector(".cart-overlay");
  const cartTarget = document.querySelector("[data-vl-cart-open]");
  const currency = window.Shopify?.currency?.active || "USD";
  const money = new Intl.NumberFormat(document.documentElement.lang || "en-US", {
    style: "currency",
    currency,
  });
  const cartFlightDuration = 1400;
  const mobileNavs = [...document.querySelectorAll("[data-vl-mobile-nav]")];
  const logoAddonHandle = "custom-logo-print";
  let currentCart = null;

  mobileNavs.forEach((mobileNav) => {
    mobileNav.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => mobileNav.removeAttribute("open"));
    });
  });

  document.addEventListener("click", (event) => {
    mobileNavs.forEach((mobileNav) => {
      if (mobileNav.open && !mobileNav.contains(event.target)) {
        mobileNav.removeAttribute("open");
      }
    });
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    mobileNavs.forEach((mobileNav) => mobileNav.removeAttribute("open"));
  });

  const moneyFromCents = (cents) => money.format((Number(cents) || 0) / 100);
  const capCatalogScript = document.querySelector("[data-vl-cap-catalog]");
  const capDefaultImage = capCatalogScript?.dataset.defaultImage || "";
  let quickCapVariants = [];

  try {
    quickCapVariants = JSON.parse(capCatalogScript?.textContent || "[]").map((variant) => {
      const color = String(variant.option1 || variant.options?.[0] || "");
      const size = String(variant.option2 || variant.options?.[1] || "");
      const fit = size.includes(" + ") ? "mixed" : size.includes("Large") ? "large" : "small";
      const pack = fit === "mixed" ? "10+10" : (size.match(/^\s*(\d+)/)?.[1] || "");
      return {
        id: Number(variant.id),
        color,
        size,
        fit,
        pack,
        price: Number(variant.price) || 0,
        available: Boolean(variant.available),
        legacy: fit === "large" && pack === "20" && /\)\s+10\s*$/.test(size),
        image:
          variant.featured_image?.src ||
          variant.featured_media?.preview_image?.src ||
          capDefaultImage,
      };
    });
  } catch (error) {
    quickCapVariants = [];
  }

  const quickCapPickers = [...document.querySelectorAll("[data-vl-cap-option-picker]")];
  const quickCapColorOrder = ["White", "Mix", "Solid Pink", "Translucent Pink", "Purple", "Blue", "Green", "Yellow", "Black"];
  const quickCapPackOrder = ["1", "4", "10", "20", "50", "100", "10+10"];

  const preferredQuickCapVariant = (records) =>
    records.find((variant) => variant.available && !variant.legacy) ||
    records.find((variant) => variant.available) ||
    records.find((variant) => !variant.legacy) ||
    records[0];

  const selectedQuickCapVariant = (picker) => {
    const selectedId = Number(picker?.dataset.vlCapVariant || 0);
    return quickCapVariants.find((variant) => variant.id === selectedId) || null;
  };

  const quickCapSelectionLabel = (variant) => {
    if (!variant) return "Choose a color and pack size";
    if (variant.fit === "mixed") return `${variant.color} · 10 small + 10 large caps`;
    const fitLabel = variant.fit === "large" ? "large 20mm" : "small 14mm";
    return `${variant.color} · ${variant.pack}-pack ${fitLabel} caps`;
  };

  function recommendedQuickCapPack(picker, availablePacks) {
    if (!availablePacks.length) return "";
    if (availablePacks.includes("10+10")) return "10+10";
    const recommended = Number(picker?.dataset.vlCapRecommended || 10);
    const numericPacks = availablePacks
      .filter((pack) => /^\d+$/.test(pack))
      .map(Number)
      .sort((a, b) => a - b);
    if (!numericPacks.length) return availablePacks[0];
    return String(numericPacks.find((pack) => pack >= recommended) || numericPacks.at(-1));
  }

  function updateQuickCapPicker(picker, { emit = true } = {}) {
    if (!picker || !quickCapVariants.length) return null;
    const fit = picker.dataset.vlCapFit || "small";
    const fitVariants = quickCapVariants.filter((variant) => variant.available && variant.fit === fit);
    if (!fitVariants.length) return null;

    let color = picker.dataset.vlCapColor || "White";
    if (!fitVariants.some((variant) => variant.color === color)) {
      color =
        quickCapColorOrder.find((candidate) => fitVariants.some((variant) => variant.color === candidate)) ||
        fitVariants[0].color;
    }

    const colorVariants = fitVariants.filter((variant) => variant.color === color);
    const availablePacks = quickCapPackOrder.filter((pack) =>
      colorVariants.some((variant) => variant.pack === pack)
    );
    let pack = picker.dataset.vlCapPack || "";
    if (!availablePacks.includes(pack)) {
      pack = recommendedQuickCapPack(picker, availablePacks);
    }

    const variant = preferredQuickCapVariant(
      colorVariants.filter((candidate) => candidate.pack === pack)
    );
    if (!variant) return null;

    picker.dataset.vlCapColor = color;
    picker.dataset.vlCapPack = pack;
    picker.dataset.vlCapVariant = String(variant.id);
    picker.dataset.vlCapPrice = String(variant.price);

    picker.querySelectorAll("[data-vl-cap-color]").forEach((button) => {
      const buttonColor = button.dataset.vlCapColor;
      const supported = fitVariants.some((candidate) => candidate.color === buttonColor);
      const selected = buttonColor === color;
      button.disabled = !supported;
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-pressed", String(selected));
    });

    picker.querySelectorAll("[data-vl-cap-pack]").forEach((button) => {
      const buttonPack = button.dataset.vlCapPack;
      const supported = availablePacks.includes(buttonPack);
      const selected = buttonPack === pack;
      button.hidden = !supported;
      button.disabled = !supported;
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-pressed", String(selected));
    });

    const colorLabel = picker.querySelector("[data-vl-cap-picker-color]");
    if (colorLabel) colorLabel.textContent = color;
    const packLabel = picker.querySelector("[data-vl-cap-picker-pack]");
    if (packLabel) packLabel.textContent = pack === "10+10" ? "10 + 10 caps" : `${pack} caps`;
    const selectionLabel = quickCapSelectionLabel(variant);
    const summary = picker.querySelector("[data-vl-cap-picker-summary]");
    if (summary) summary.textContent = selectionLabel;
    const price = picker.querySelector("[data-vl-cap-picker-price]");
    if (price) price.textContent = moneyFromCents(variant.price);

    const surface = picker.closest("[data-vl-cap-surface]") || picker.parentElement;
    const image = surface?.querySelector("[data-vl-cap-picker-image]");
    if (image && variant.image) {
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.src = variant.image;
      image.alt = `${variant.color} VialLock vial caps`;
    }

    if (picker.dataset.vlCapContext === "finder") {
      const label = document.querySelector("[data-vl-finder-caps-label]");
      if (label) label.textContent = `${selectionLabel} · ${moneyFromCents(variant.price)}`;
    } else if (picker.dataset.vlCapContext === "complete") {
      const name = document.querySelector("[data-vl-complete-cap-name]");
      const capPrice = document.querySelector("[data-vl-complete-cap-price]");
      if (name) name.textContent = selectionLabel;
      if (capPrice) capPrice.textContent = moneyFromCents(variant.price);
    } else if (picker.dataset.vlCapContext === "product") {
      const name = document.querySelector("[data-vl-product-cap-name]");
      const capPrice = document.querySelector("[data-vl-product-cap-price]");
      if (name) name.textContent = selectionLabel;
      if (capPrice) capPrice.textContent = `+${moneyFromCents(variant.price)}`;
    } else if (picker.dataset.vlCapContext === "drawer") {
      const name = picker.closest("[data-vl-cap-upsell]")?.querySelector("[data-vl-cap-upsell-name]");
      const capPrice = picker.closest("[data-vl-cap-upsell]")?.querySelector("[data-vl-cap-upsell-price]");
      const add = picker.closest("[data-vl-cap-upsell]")?.querySelector("[data-vl-add-variant]");
      if (name) name.textContent = selectionLabel;
      if (capPrice) capPrice.textContent = `Add for ${moneyFromCents(variant.price)}`;
      if (add) add.dataset.vlAddVariant = String(variant.id);
    } else if (picker.dataset.vlCapContext === "cart-page") {
      const name = picker.closest("[data-vl-cart-page-cap-offer]")?.querySelector("[data-vl-cart-page-cap-name]");
      const add = picker.closest("[data-vl-cart-page-cap-offer]")?.querySelector("[data-vl-cart-page-add]");
      if (name) name.textContent = selectionLabel;
      if (add) add.dataset.vlCartPageAdd = String(variant.id);
    }

    if (emit) {
      picker.dispatchEvent(new CustomEvent("vl:cap-selection-change", {
        bubbles: true,
        detail: { variant },
      }));
    }
    return variant;
  }

  function setQuickCapPickerFit(picker, fit, recommendedCount) {
    if (!picker) return null;
    const nextFit = fit || "small";
    const fitChanged = picker.dataset.vlCapFit !== nextFit;
    const recommendationChanged =
      recommendedCount != null &&
      picker.dataset.vlCapRecommended !== String(recommendedCount);
    picker.dataset.vlCapFit = nextFit;
    if (recommendedCount != null) picker.dataset.vlCapRecommended = String(recommendedCount);
    if (fitChanged) {
      picker.dataset.vlCapPack = nextFit === "mixed" ? "10+10" : "";
      delete picker.dataset.vlCapUserPack;
    } else if (recommendationChanged && !picker.dataset.vlCapUserPack) {
      picker.dataset.vlCapPack = "";
    }
    return updateQuickCapPicker(picker, { emit: false });
  }

  function syncQuickCapPickerToggle(picker) {
    if (!picker) return;
    const context = picker.dataset.vlCapContext;
    const toggle = [...document.querySelectorAll("[data-vl-cap-toggle]")].find(
      (input) => input.dataset.vlCapToggle === context
    );
    if (toggle) picker.hidden = !toggle.checked;
  }

  quickCapPickers.forEach((picker) => {
    picker.querySelectorAll("[data-vl-cap-color]").forEach((button) => {
      button.addEventListener("click", () => {
        picker.dataset.vlCapColor = button.dataset.vlCapColor;
        updateQuickCapPicker(picker);
      });
    });
    picker.querySelectorAll("[data-vl-cap-pack]").forEach((button) => {
      button.addEventListener("click", () => {
        picker.dataset.vlCapPack = button.dataset.vlCapPack;
        picker.dataset.vlCapUserPack = "true";
        updateQuickCapPicker(picker);
      });
    });
    const context = picker.dataset.vlCapContext;
    const toggle = [...document.querySelectorAll("[data-vl-cap-toggle]")].find(
      (input) => input.dataset.vlCapToggle === context
    );
    toggle?.addEventListener("change", () => syncQuickCapPickerToggle(picker));
    updateQuickCapPicker(picker, { emit: false });
    syncQuickCapPickerToggle(picker);
  });

  const compactCartViewport = window.matchMedia("(max-width: 700px), (max-height: 900px)");

  function setCapUpsellExpanded(upsell, expanded) {
    if (!upsell) return;
    const toggle = upsell.querySelector("[data-vl-cap-upsell-toggle]");
    const panel = upsell.querySelector("[data-vl-cap-upsell-panel]");
    const label = upsell.querySelector("[data-vl-cap-upsell-toggle-label]");
    upsell.classList.toggle("is-collapsed", !expanded);
    toggle?.setAttribute("aria-expanded", String(expanded));
    if (panel) panel.hidden = !expanded;
    if (label) label.textContent = expanded ? "Hide options" : "Choose VialCaps";
  }

  function syncCapUpsellForViewport() {
    const upsell = drawer?.querySelector("[data-vl-cap-upsell]");
    if (!upsell) return;
    const manualPreference = upsell.dataset.vlCapUpsellExpanded;
    const expanded = manualPreference == null
      ? !compactCartViewport.matches
      : manualPreference === "true";
    setCapUpsellExpanded(upsell, expanded);
  }

  compactCartViewport.addEventListener?.("change", syncCapUpsellForViewport);
  syncCapUpsellForViewport();

  function openCart() {
    syncCapUpsellForViewport();
    drawer?.classList.add("open");
    overlay?.classList.add("open");
    drawer?.setAttribute("aria-hidden", "false");
    root.classList.add("vl-cart-drawer-open");
    root.style.overflow = "hidden";
  }

  function closeCart() {
    drawer?.classList.remove("open");
    overlay?.classList.remove("open");
    drawer?.setAttribute("aria-hidden", "true");
    root.classList.remove("vl-cart-drawer-open");
    root.style.overflow = "";
  }

  function flyToCart(source, image) {
    if (!source || !image || !cartTarget || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return Promise.resolve();
    }
    const isVisibleFlightSource = (element) => {
      const rect = element?.getBoundingClientRect();
      return Boolean(
        rect &&
        rect.width > 0 &&
        rect.height > 0 &&
        rect.bottom > 0 &&
        rect.top < window.innerHeight &&
        rect.right > 0 &&
        rect.left < window.innerWidth
      );
    };
    const visibleFallback = [
      document.querySelector("[data-vl-product-submit]"),
      document.querySelector("[data-vl-sticky-submit]"),
    ].find(isVisibleFlightSource);
    const flightSource = isVisibleFlightSource(source) ? source : visibleFallback || source;
    const sourceRect = flightSource.getBoundingClientRect();
    const visibleCartRect = cartTarget.getBoundingClientRect();
    const targetRect = isVisibleFlightSource(cartTarget)
      ? visibleCartRect
      : {
          left: window.innerWidth - 80,
          top: 20,
          width: 56,
          height: 56,
        };
    const size = Math.max(56, Math.min(sourceRect.width || 90, 130));
    const startLeft = sourceRect.left + Math.max(0, (sourceRect.width - size) / 2);
    const startTop = sourceRect.top + Math.max(0, (sourceRect.height - size) / 2);
    const targetLeft = targetRect.left + Math.max(0, (targetRect.width - size) / 2);
    const targetTop = targetRect.top + Math.max(0, (targetRect.height - size) / 2);
    const flyer = document.createElement("img");
    flyer.className = "pdp-cart-flyer";
    flyer.src = image;
    flyer.alt = "";
    flyer.style.top = `${startTop}px`;
    flyer.style.left = `${startLeft}px`;
    flyer.style.width = `${size}px`;
    flyer.style.height = `${size}px`;
    flyer.style.setProperty("--fly-x", `${targetLeft - startLeft}px`);
    flyer.style.setProperty("--fly-y", `${targetTop - startTop}px`);
    document.body.appendChild(flyer);
    requestAnimationFrame(() => flyer.classList.add("animate"));
    return new Promise((resolve) => {
      window.setTimeout(() => {
        flyer.remove();
        resolve();
      }, cartFlightDuration);
    });
  }

  async function fetchCart() {
    const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error("Unable to load the bag.");
    return response.json();
  }

  function isLogoAddonItem(item) {
    return item?.handle === logoAddonHandle || item?.properties?._vl_logo_addon === "true";
  }

  function logoGroupFor(item) {
    return String(item?.properties?._vl_logo_group || "");
  }

  function visibleCartItemCount(cart) {
    return (cart?.items || []).reduce(
      (count, item) => count + (isLogoAddonItem(item) ? 0 : Math.max(0, Number(item.quantity) || 0)),
      0,
    );
  }

  function cartLinePropertiesMarkup(item) {
    const properties = item?.properties || {};
    const parts = [];
    if (properties["Logo artwork"]) {
      const value = String(properties["Logo artwork"]);
      let link = "";
      try {
        const url = new URL(value, window.location.origin);
        if (["http:", "https:"].includes(url.protocol)) link = url.href;
      } catch (error) {
        link = "";
      }
      parts.push(link
        ? `<a href="${escapeHtml(link)}" target="_blank" rel="noopener">Logo artwork attached ↗</a>`
        : "<span>Logo artwork attached ✓</span>");
    }
    if (properties["Logo instructions"]) {
      parts.push(`<span>Note: ${escapeHtml(properties["Logo instructions"])}</span>`);
    }
    return parts.length ? `<div class="cart-line-properties">${parts.join("")}</div>` : "";
  }

  function updatesForCartLine(cart, key, quantity) {
    const target = cart?.items?.find((item) => item.key === key);
    const group = logoGroupFor(target);
    if (!target || !group || isLogoAddonItem(target)) return { [key]: quantity };
    return cart.items.reduce((updates, item) => {
      if (logoGroupFor(item) === group) updates[item.key] = quantity;
      return updates;
    }, {});
  }

  async function updateCartLines(updates) {
    const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates }),
    });
    if (!response.ok) {
      const problem = await response.json().catch(() => ({}));
      throw new Error(problem.description || "Unable to update this quantity.");
    }
    return response.json();
  }

  function cartLineMarkup(item) {
    const logoAddon = isLogoAddonItem(item);
    const image = item.image
      ? `<img src="${item.image}" alt="${escapeHtml(item.product_title || item.title)}" width="82" height="82">`
      : "";
    const title = String(item.product_title || item.title || "").split("|")[0].trim();
    const variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
    const quantity = Math.max(1, Number(item.quantity) || 1);
    const key = escapeHtml(item.key);
    const safeTitle = escapeHtml(title);
    const group = escapeHtml(logoGroupFor(item));
    if (logoAddon) {
      return `
        <div class="cart-line cart-line--logo" data-key="${key}" data-vl-logo-group="${group}">
          <span class="cart-line-logo-mark" aria-hidden="true">+</span>
          <div class="cart-line-copy">
            <strong>Custom logo print</strong>
            <span>Matched to your case · Qty ${quantity}</span>
            <div class="cart-line-purchase"><span>Updates with case quantity</span></div>
          </div>
          <b>${moneyFromCents(item.final_line_price)}</b>
        </div>
      `;
    }
    return `
      <div class="cart-line" data-key="${key}" data-vl-logo-group="${group}">
        ${image}
        <div class="cart-line-copy">
          <strong>${safeTitle}</strong>
          <span>${escapeHtml(variant)}</span>
          ${cartLinePropertiesMarkup(item)}
          <div class="cart-line-purchase">
            <div class="cart-line-quantity" role="group" aria-label="Quantity for ${safeTitle}" data-vl-cart-quantity-control>
              <button type="button" data-vl-cart-quantity="${key}" data-vl-cart-quantity-value="${Math.max(0, quantity - 1)}" aria-label="Decrease quantity of ${safeTitle}">−</button>
              <span><small>Qty</small><output aria-live="polite">${quantity}</output></span>
              <button type="button" data-vl-cart-quantity="${key}" data-vl-cart-quantity-value="${quantity + 1}" aria-label="Increase quantity of ${safeTitle}">+</button>
            </div>
            <b>${moneyFromCents(item.final_line_price)}</b>
          </div>
        </div>
        <button class="cart-line-remove" type="button" data-vl-cart-remove="${key}" aria-label="Remove ${safeTitle}">×</button>
      </div>
    `;
  }

  function escapeHtml(value) {
    return String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function renderCart(cart) {
    currentCart = cart;
    const visibleItemCount = visibleCartItemCount(cart);
    document.querySelectorAll("[data-vl-cart-count]").forEach((node) => {
      node.textContent = visibleItemCount;
    });
    document.querySelectorAll("[data-vl-cart-open]").forEach((node) => {
      node.setAttribute("aria-label", `Open cart with ${visibleItemCount} items`);
    });

    const countLabel = drawer?.querySelector(".cart-head strong");
    if (countLabel) countLabel.innerHTML = `<span data-vl-cart-count>${visibleItemCount}</span> ${visibleItemCount === 1 ? "ITEM" : "ITEMS"}`;

    const items = drawer?.querySelector("[data-vl-cart-items]");
    if (items) {
      items.innerHTML = cart.item_count
        ? cart.items.map(cartLineMarkup).join("")
        : `<div class="empty-cart"><span aria-hidden="true">○</span><h3>Your bag is empty.</h3><p>Start with your vial size and capacity, then choose the case that fits your routine.</p></div>`;
    }

    const total = drawer?.querySelector("[data-vl-cart-total]");
    if (total) total.textContent = moneyFromCents(cart.total_price);

    const remaining = Math.max(0, 3500 - cart.total_price);
    const shippingCopy = drawer?.querySelector("[data-vl-shipping-copy]");
    if (shippingCopy) {
      shippingCopy.textContent = remaining === 0
        ? "You unlocked free shipping."
        : `${moneyFromCents(remaining)} away from free shipping.`;
    }
    const shippingProgress = drawer?.querySelector("[data-vl-shipping-progress]");
    if (shippingProgress) shippingProgress.style.width = `${Math.min(100, (cart.total_price / 3500) * 100)}%`;

    const primary = drawer?.querySelector("[data-vl-cart-primary]");
    if (primary) {
      primary.textContent = visibleItemCount ? "Secure checkout →" : "Choose a product →";
      primary.href = visibleItemCount ? "/checkout" : "/collections/all-cases";
      primary.classList.toggle("disabled", visibleItemCount === 0);
    }
    const review = drawer?.querySelector("[data-vl-cart-review]");
    review?.toggleAttribute("hidden", visibleItemCount === 0);

    const capHandle = "viallock-flexible-tpu-vial-caps-reusable-protective-caps-for-3ml-5ml-10ml-vials";
    const isCapItem = (item) => item.handle === capHandle || /Flexible TPU Vial Caps/i.test(item.product_title || item.title);
    const hasCaps = cart.items.some(isCapItem);
    const hasSmallCase = cart.items.some((item) => (
      !isCapItem(item) && !isLogoAddonItem(item)
      && /3\s*mL/i.test(item.product_title || item.title)
    ));
    const hasLargeCase = cart.items.some((item) => (
      !isCapItem(item) && !isLogoAddonItem(item)
      && /10\s*mL/i.test(item.product_title || item.title)
    ));
    const capFit = hasSmallCase && hasLargeCase ? "mixed" : hasLargeCase ? "large" : hasSmallCase ? "small" : "";
    const capUpsell = drawer?.querySelector("[data-vl-cap-upsell]");
    capUpsell?.toggleAttribute("hidden", hasCaps || visibleItemCount === 0 || !capFit);
    if (capUpsell && !hasCaps && visibleItemCount > 0 && capFit) {
      const picker = capUpsell.querySelector("[data-vl-cap-option-picker]");
      setQuickCapPickerFit(picker, capFit);
    }
    syncCapUpsellForViewport();
  }

  async function addItems(items, source, image) {
    if (!items.length) return;
    const cartFlight = flyToCart(source, image);
    const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items }),
    });
    if (!response.ok) {
      const problem = await response.json().catch(() => ({}));
      throw new Error(problem.description || "This selection could not be added.");
    }
    document.dispatchEvent(new CustomEvent("vl:cart:add", { detail: { items } }));
    renderCart(await fetchCart());
    await cartFlight;
    openCart();
  }

  document.addEventListener("click", async (event) => {
    const open = event.target.closest("[data-vl-cart-open]");
    if (open) {
      event.preventDefault();
      openCart();
      return;
    }

    if (event.target.closest("[data-vl-cart-close]")) {
      event.preventDefault();
      closeCart();
      return;
    }

    const capUpsellToggle = event.target.closest("[data-vl-cap-upsell-toggle]");
    if (capUpsellToggle) {
      event.preventDefault();
      const upsell = capUpsellToggle.closest("[data-vl-cap-upsell]");
      const expanded = capUpsellToggle.getAttribute("aria-expanded") === "true";
      if (upsell) upsell.dataset.vlCapUpsellExpanded = String(!expanded);
      setCapUpsellExpanded(upsell, !expanded);
      return;
    }

    const scrollButton = event.target.closest("[data-vl-scroll]");
    if (scrollButton) {
      event.preventDefault();
      document.querySelector(scrollButton.dataset.vlScroll)?.scrollIntoView({ behavior: "smooth" });
      document.querySelector(scrollButton.dataset.vlScroll)?.querySelector(".finder-card")?.classList.add("finder-active");
      return;
    }

    const addButton = event.target.closest("[data-vl-add-variant]");
    if (addButton) {
      event.preventDefault();
      addButton.disabled = true;
      try {
        await addItems(
          [{ id: Number(addButton.dataset.vlAddVariant), quantity: 1 }],
          addButton.closest(".product-card, .cart-upsell, .pdp-buy-panel")?.querySelector("img") || addButton,
          addButton.dataset.vlAddImage || addButton.closest(".product-card, .cart-upsell")?.querySelector("img")?.currentSrc,
        );
      } catch (error) {
        window.alert(error.message);
      } finally {
        addButton.disabled = false;
      }
      return;
    }

    const quantityButton = event.target.closest("[data-vl-cart-quantity]");
    if (quantityButton) {
      event.preventDefault();
      const quantityControl = quantityButton.closest("[data-vl-cart-quantity-control]");
      const quantityButtons = quantityControl?.querySelectorAll("button") || [quantityButton];
      quantityButtons.forEach((button) => {
        button.disabled = true;
      });
      quantityControl?.setAttribute("aria-busy", "true");
      try {
        const nextQuantity = Math.max(0, Number(quantityButton.dataset.vlCartQuantityValue) || 0);
        const cart = currentCart || await fetchCart();
        const updates = updatesForCartLine(cart, quantityButton.dataset.vlCartQuantity, nextQuantity);
        renderCart(await updateCartLines(updates));
      } catch (error) {
        window.alert(error.message);
        quantityControl?.removeAttribute("aria-busy");
        quantityButtons.forEach((button) => {
          button.disabled = false;
        });
      }
      return;
    }

    const removeButton = event.target.closest("[data-vl-cart-remove]");
    if (removeButton) {
      event.preventDefault();
      removeButton.disabled = true;
      try {
        const cart = currentCart || await fetchCart();
        const updates = updatesForCartLine(cart, removeButton.dataset.vlCartRemove, 0);
        renderCart(await updateCartLines(updates));
      } catch (error) {
        window.alert(error.message);
        removeButton.disabled = false;
      }
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeCart();
  });

  const finderScript = document.querySelector("[data-vl-finder-products]");
  let finderProducts = [];
  try {
    finderProducts = finderScript ? JSON.parse(finderScript.textContent || "[]") : [];
  } catch (error) {
    console.error("VialLock case-finder data could not be read.", error);
  }
  const finder = document.querySelector("[data-vl-finder]");
  const finderCapPicker = finder?.querySelector('[data-vl-cap-context="finder"]');
  let finderSize = "3mL";
  let finderSetup = "vials-only";
  let finderImageRequest = 0;

  const capFitForSize = (size) => size === "10mL"
    ? {
        fit: "large",
        fitCopy: "Large caps · 20mm · for 10mL cases",
        label: "10‑Pack Large Caps · for 10mL cases",
      }
    : {
        fit: "small",
        fitCopy: "Small caps · 14mm · for 3mL cases",
        label: "10‑Pack Small Caps · for 3mL cases",
      };

  function updateFinderRange() {
    const range = finder?.querySelector("[data-vl-finder-count]");
    if (!range) return;
    const min = Number(range.min || 1);
    const max = Number(range.max || 100);
    const value = Number(range.value || min);
    const progress = max === min ? 0 : ((value - min) / (max - min)) * 100;
    range.style.setProperty("--vl-range-progress", `${progress}%`);
    range.setAttribute("aria-valuetext", `${value} ${value === 1 ? "vial" : "vials"}`);
    const maximum = finder.querySelector("[data-vl-finder-max]");
    if (maximum) maximum.textContent = `${max} vials`;
  }

  function finderMaximum() {
    if (finderSetup === "with-bac") return 12;
    return finderSize === "10mL" ? 50 : 100;
  }

  function syncFinderSetupControls() {
    if (!finder) return;
    const bacButton = finder.querySelector('[data-vl-finder-setup="with-bac"]');
    if (bacButton) {
      bacButton.disabled = finderSize !== "3mL";
      bacButton.setAttribute(
        "aria-disabled",
        finderSize !== "3mL" ? "true" : "false",
      );
    }
    finder.querySelectorAll("[data-vl-finder-setup]").forEach((button) => {
      const active = button.dataset.vlFinderSetup === finderSetup;
      button.classList.toggle("active", active);
      button.setAttribute("aria-pressed", active ? "true" : "false");
    });
  }

  function syncFinderMaximum() {
    const range = finder?.querySelector("[data-vl-finder-count]");
    if (!range) return;
    range.max = String(finderMaximum());
    range.value = String(Math.min(Number(range.value), Number(range.max)));
  }

  function finderRecommendation() {
    if (!finder) return null;
    const requested = Number(finder.querySelector("[data-vl-finder-count]")?.value || 1);
    const wantsBac = finderSetup === "with-bac";
    const products = finderProducts
      .filter((product) => product.size === finderSize && Boolean(product.bacSlot) === wantsBac)
      .sort((a, b) => a.capacity - b.capacity);
    return products.find((product) => product.capacity >= requested) || products.at(-1) || null;
  }

  function updateFinderImage(product) {
    const image = finder?.querySelector("[data-vl-finder-image]");
    if (!image || !product?.image) return;

    const request = ++finderImageRequest;
    const productKey = String(product.variantId);
    const result = image.closest(".finder-result");

    if (image.dataset.vlFinderProduct === productKey) {
      image.alt = product.title;
      image.classList.add("is-loaded");
      finder.classList.remove("finder-image-loading");
      result?.setAttribute("aria-busy", "false");
      return;
    }

    finder.classList.add("finder-image-loading");
    image.classList.remove("is-loaded");
    result?.setAttribute("aria-busy", "true");

    const preloader = new window.Image();
    preloader.onload = () => {
      if (request !== finderImageRequest) return;
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");
      image.src = product.image;
      image.alt = product.title;
      image.dataset.vlFinderProduct = productKey;
      image.classList.add("is-loaded");
      finder.classList.remove("finder-image-loading");
      result?.setAttribute("aria-busy", "false");
    };
    preloader.onerror = () => {
      if (request !== finderImageRequest) return;
      image.classList.add("is-loaded");
      finder.classList.remove("finder-image-loading");
      result?.setAttribute("aria-busy", "false");
    };
    preloader.src = product.image;
  }

  function updateFinder() {
    const product = finderRecommendation();
    if (!finder || !product) return;
    const count = finder.querySelector("[data-vl-finder-count]");
    const output = finder.querySelector("[data-vl-finder-output]");
    if (output && count) output.textContent = count.value;
    updateFinderImage(product);
    const name = finder.querySelector("[data-vl-finder-name]");
    if (name) name.textContent = product.name;
    const meta = finder.querySelector("[data-vl-finder-meta]");
    if (meta) meta.textContent = product.meta;
    const bacDetail = finder.querySelector("[data-vl-finder-bac-detail]");
    if (bacDetail) bacDetail.hidden = !product.bacSlot;
    const capFit = capFitForSize(finderSize);
    setQuickCapPickerFit(finderCapPicker, capFit.fit, product.capacity);
    const fitCopy = finder.querySelector("[data-vl-finder-cap-fit]");
    if (fitCopy) fitCopy.textContent = capFit.fitCopy;
    const add = finder.querySelector("[data-vl-finder-add]");
    if (add) {
      add.dataset.caseVariant = product.variantId;
      add.dataset.casePrice = product.price;
      add.dataset.caseImage = product.image;
    }
    const view = finder.querySelector("[data-vl-finder-view]");
    if (view) view.href = product.url;
    updateFinderRange();
    updateFinderTotal();
  }

  function updateFinderTotal() {
    if (!finder) return;
    const add = finder.querySelector("[data-vl-finder-add]");
    const includeCaps = finder.querySelector("[data-vl-finder-caps]")?.checked;
    const capFit = capFitForSize(finderSize);
    const selectedCaps = selectedQuickCapVariant(finderCapPicker);
    const capPrice = selectedCaps?.price || 0;
    const total = Number(add?.dataset.casePrice || 0) + (includeCaps ? Number(capPrice || 0) : 0);
    const price = finder.querySelector("[data-vl-finder-price]");
    if (price) price.textContent = moneyFromCents(total);
    if (add) add.textContent = includeCaps ? "Add both" : "Add case";
    const capsLabel = finder.querySelector("[data-vl-finder-caps-label]");
    if (capsLabel) {
      capsLabel.textContent = selectedCaps
        ? `${quickCapSelectionLabel(selectedCaps)} · ${moneyFromCents(capPrice)}`
        : "Choose a color and pack size";
    }
  }

  finder?.querySelectorAll("[data-vl-finder-size]").forEach((button) => {
    button.addEventListener("click", () => {
      finderSize = button.dataset.vlFinderSize;
      if (finderSize !== "3mL") finderSetup = "vials-only";
      finder.querySelectorAll("[data-vl-finder-size]").forEach((item) => item.classList.toggle("active", item === button));
      syncFinderSetupControls();
      syncFinderMaximum();
      const check = finder.querySelector("[data-vl-finder-caps]");
      if (check) check.checked = false;
      syncQuickCapPickerToggle(finderCapPicker);
      updateFinder();
    });
  });
  finder?.querySelectorAll("[data-vl-finder-setup]").forEach((button) => {
    button.addEventListener("click", () => {
      if (button.disabled) return;
      finderSetup = button.dataset.vlFinderSetup;
      syncFinderSetupControls();
      syncFinderMaximum();
      const check = finder.querySelector("[data-vl-finder-caps]");
      if (check) check.checked = false;
      syncQuickCapPickerToggle(finderCapPicker);
      updateFinder();
    });
  });
  finder?.querySelector("[data-vl-finder-count]")?.addEventListener("input", updateFinder);
  finder?.querySelector("[data-vl-finder-count]")?.addEventListener("change", updateFinder);
  finder?.querySelectorAll("[data-vl-finder-step]").forEach((button) => {
    button.addEventListener("click", () => {
      const range = finder.querySelector("[data-vl-finder-count]");
      if (!range) return;
      const next = Math.min(
        Number(range.max),
        Math.max(Number(range.min), Number(range.value) + Number(button.dataset.vlFinderStep || 0)),
      );
      range.value = String(next);
      updateFinder();
      range.focus();
    });
  });
  finder?.querySelector("[data-vl-finder-caps]")?.addEventListener("change", updateFinderTotal);
  finderCapPicker?.addEventListener("vl:cap-selection-change", updateFinderTotal);
  finder?.querySelector("[data-vl-finder-add]")?.addEventListener("click", async (event) => {
    const button = event.currentTarget;
    const includeCaps = finder.querySelector("[data-vl-finder-caps]")?.checked;
    const items = [{ id: Number(button.dataset.caseVariant), quantity: 1 }];
    if (includeCaps) {
      const selectedCaps = selectedQuickCapVariant(finderCapPicker);
      if (!selectedCaps) return;
      items.push({
        id: selectedCaps.id,
        quantity: 1,
      });
    }
    button.disabled = true;
    try {
      await addItems(items, finder.querySelector("[data-vl-finder-image]"), button.dataset.caseImage);
    } catch (error) {
      window.alert(error.message);
    } finally {
      button.disabled = false;
    }
  });
  syncFinderSetupControls();
  syncFinderMaximum();
  updateFinder();

  const filters = [...document.querySelectorAll("[data-vl-filter]")];
  const resetFilters = document.querySelector("[data-vl-filter-reset]");
  const productCards = [...document.querySelectorAll("[data-vl-product-grid] .product-card")];
  const filterSummary = document.querySelector("[data-vl-filter-summary]");
  const searchInput = document.querySelector("[data-vl-filter-search]");
  const searchClear = document.querySelector("[data-vl-search-clear]");
  const searchableFeatureItems = [...document.querySelectorAll("[data-vl-search-item]")];
  const filterEmptyState = document.querySelector("[data-vl-filter-empty]");
  const clearAllFilters = document.querySelector("[data-vl-filter-clear-all]");

  function normalizedCatalogSearch(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/[–—‑]/g, "-")
      .replace(/[^a-z0-9]+/g, " ")
      .replace(/\b(\d+)\s+ml\b/g, "$1ml")
      .trim();
  }

  function catalogSearchMatches(searchText, query) {
    if (!query) return true;
    const searchableText = normalizedCatalogSearch(searchText);
    return query.split(" ").every((term) => searchableText.includes(term));
  }

  function applyFilters() {
    const selections = Object.fromEntries(filters.map((select) => [select.dataset.vlFilter, select.value]));
    const rawQuery = searchInput?.value.trim() || "";
    const query = normalizedCatalogSearch(rawQuery);
    let visible = 0;
    productCards.forEach((card) => {
      const matchesSelections = Object.entries(selections).every(
        ([key, value]) => value === "all" || card.dataset[key] === value,
      );
      const matchesSearch =
        catalogSearchMatches(card.dataset.vlSearchText || card.dataset.shopifyTitle, query);
      const matches = matchesSelections && matchesSearch;
      card.hidden = !matches;
      if (matches) visible += 1;
    });

    let visibleFeatureItems = 0;
    searchableFeatureItems.forEach((item) => {
      const matchesSearch = catalogSearchMatches(item.dataset.vlSearchText, query);
      item.hidden = !matchesSearch;
      if (matchesSearch && query) visibleFeatureItems += 1;
    });

    if (filterSummary) {
      const filterUnit = filterSummary.dataset.vlFilterUnit || "products";
      filterSummary.textContent = query
        ? `Showing ${visible + visibleFeatureItems} result${visible + visibleFeatureItems === 1 ? "" : "s"} for “${rawQuery}”`
        : `Showing ${visible} of ${productCards.length} matching ${filterUnit}`;
    }
    const resultCount = visible + (query ? visibleFeatureItems : 0);
    if (filterEmptyState) filterEmptyState.hidden = resultCount > 0;
    if (searchClear) searchClear.hidden = !query;
    if (resetFilters) {
      resetFilters.disabled =
        !query && Object.values(selections).every((value) => value === "all");
    }
  }

  function resetCatalogFilters() {
    filters.forEach((select) => {
      select.value = "all";
    });
    if (searchInput) searchInput.value = "";
    applyFilters();
  }

  filters.forEach((select) => select.addEventListener("change", applyFilters));
  document.querySelectorAll("[data-vl-search-link]").forEach((link) => {
    link.addEventListener("click", (event) => {
      if (!searchInput || !link.getAttribute("href")?.startsWith("#")) return;
      event.preventDefault();
      document.querySelector("#catalog-search")?.scrollIntoView({ behavior: "smooth", block: "center" });
      window.setTimeout(() => searchInput.focus({ preventScroll: true }), 450);
    });
  });
  searchInput?.addEventListener("input", applyFilters);
  searchInput?.addEventListener("keydown", (event) => {
    if (event.key !== "Escape" || !searchInput.value) return;
    searchInput.value = "";
    applyFilters();
    searchInput.focus();
  });
  searchClear?.addEventListener("click", () => {
    searchInput.value = "";
    applyFilters();
    searchInput.focus();
  });
  resetFilters?.addEventListener("click", resetCatalogFilters);
  clearAllFilters?.addEventListener("click", resetCatalogFilters);
  applyFilters();

  const complete = document.querySelector("[data-vl-complete]");
  const completeCapPicker = complete?.querySelector('[data-vl-cap-context="complete"]');
  function updateComplete() {
    if (!complete) return;
    const select = complete.querySelector("[data-vl-complete-select]");
    const option = select?.selectedOptions?.[0];
    if (!option) return;
    const includeCaps = complete.querySelector("[data-vl-complete-caps]")?.checked;
    const fit = option.dataset.fit || "small";
    const button = complete.querySelector("[data-vl-complete-add]");
    setQuickCapPickerFit(completeCapPicker, fit, Number(option.dataset.capacity || 10));
    const selectedCaps = selectedQuickCapVariant(completeCapPicker);
    const capPrice = Number(selectedCaps?.price || 0);
    const casePrice = Number(option.dataset.price || 0);
    const image = complete.querySelector("[data-vl-complete-case-image]");
    if (image) {
      image.src = option.dataset.image;
      image.alt = option.dataset.name;
    }
    complete.querySelector("[data-vl-complete-case-name]").textContent = option.dataset.name;
    complete.querySelector("[data-vl-complete-case-price]").textContent = option.dataset.money;
    complete.querySelector("[data-vl-complete-cap-name]").textContent = quickCapSelectionLabel(selectedCaps);
    complete.querySelector("[data-vl-complete-cap-price]").textContent = moneyFromCents(capPrice);
    complete.querySelector("[data-vl-complete-fit]").textContent = fit === "large"
      ? "Large caps · 20mm / 0.78 in · for 10mL cases"
      : "Small caps · 14mm / 0.55 in · for 3mL cases";
    complete.querySelector("[data-vl-complete-cap-card]")?.classList.toggle("optional", !includeCaps);
    complete.querySelector("[data-vl-complete-total-label]").textContent = includeCaps ? "Combined price" : "Case price";
    complete.querySelector("[data-vl-complete-total]").textContent = moneyFromCents(casePrice + (includeCaps ? capPrice : 0));
    if (button) button.innerHTML = `${includeCaps ? "Add both products" : "Add case only"} <span aria-hidden="true">↗</span>`;
  }
  complete?.querySelector("[data-vl-complete-select]")?.addEventListener("change", () => {
    const check = complete.querySelector("[data-vl-complete-caps]");
    if (check) check.checked = false;
    delete completeCapPicker?.dataset.vlCapUserPack;
    syncQuickCapPickerToggle(completeCapPicker);
    updateComplete();
  });
  complete?.querySelector("[data-vl-complete-caps]")?.addEventListener("change", updateComplete);
  completeCapPicker?.addEventListener("vl:cap-selection-change", updateComplete);
  complete?.querySelector("[data-vl-complete-add]")?.addEventListener("click", async (event) => {
    const select = complete.querySelector("[data-vl-complete-select]");
    const option = select?.selectedOptions?.[0];
    const includeCaps = complete.querySelector("[data-vl-complete-caps]")?.checked;
    if (!option) return;
    const fit = option.dataset.fit || "small";
    const button = event.currentTarget;
    const items = [{ id: Number(option.value), quantity: 1 }];
    if (includeCaps) {
      const selectedCaps = selectedQuickCapVariant(completeCapPicker);
      if (!selectedCaps) return;
      items.push({
        id: selectedCaps.id,
        quantity: 1,
      });
    }
    button.disabled = true;
    try {
      await addItems(items, complete.querySelector("[data-vl-complete-case-image]"), option.dataset.image);
    } catch (error) {
      window.alert(error.message);
    } finally {
      button.disabled = false;
    }
  });
  updateComplete();

  document.querySelectorAll("[data-vl-klaviyo-trigger]").forEach((button) => {
    button.addEventListener("click", () => {
      const formId = button.dataset.klaviyoFormId;
      if (!formId) return;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(["openForm", formId]);
    });
  });

  const productPage = document.querySelector("[data-vl-product-page]");
  const productForm = productPage?.querySelector("[data-vl-product-form]");
  const variantControl = productForm?.querySelector("[data-vl-product-variant]");
  const capControl = productForm?.querySelector("[data-vl-product-caps]");
  const productCapPicker = productForm?.querySelector('[data-vl-cap-context="product"]');
  const primaryProductButton = productForm?.querySelector("[data-vl-product-submit]");
  const capPicker = productForm?.querySelector("[data-vl-cap-picker]");
  const casePicker = productForm?.querySelector("[data-vl-case-picker]");
  const productQuantityInput = productForm?.querySelector("[data-vl-product-quantity]");
  const productQuantityMinus = productForm?.querySelector("[data-vl-product-quantity-minus]");
  const productQuantityPlus = productForm?.querySelector("[data-vl-product-quantity-plus]");
  const logoOption = productForm?.querySelector("[data-vl-logo-option]");
  const logoToggle = logoOption?.querySelector("[data-vl-logo-toggle]");
  const logoFields = logoOption?.querySelector("[data-vl-logo-fields]");
  const logoFile = logoOption?.querySelector("[data-vl-logo-file]");
  const logoFileStatus = logoOption?.querySelector("[data-vl-logo-file-status]");
  const logoInstructions = logoOption?.querySelector("[data-vl-logo-instructions]");
  const logoRights = logoOption?.querySelector("[data-vl-logo-rights]");
  const logoProperty = logoOption?.querySelector("[data-vl-logo-property]");
  const logoGroup = logoOption?.querySelector("[data-vl-logo-group]");
  const logoMaximumBytes = 20 * 1024 * 1024;

  const productImageTrigger = productPage?.querySelector("[data-vl-product-image-trigger]");
  const productLightbox = productPage?.querySelector("[data-vl-product-lightbox]");
  const productLightboxViewport = productLightbox?.querySelector("[data-vl-product-lightbox-viewport]");
  const productLightboxImage = productLightbox?.querySelector("[data-vl-product-lightbox-image]");
  const productZoomLevel = productLightbox?.querySelector("[data-vl-product-zoom-level]");
  const productZoomOut = productLightbox?.querySelector("[data-vl-product-zoom-out]");
  const productZoomIn = productLightbox?.querySelector("[data-vl-product-zoom-in]");
  const productZoomReset = productLightbox?.querySelector("[data-vl-product-zoom-reset]");
  const productLightboxInstructions = productLightbox?.querySelector("[data-vl-product-lightbox-instructions]");
  const minimumProductZoom = 1;
  const maximumProductZoom = 4;
  const productZoomStep = 0.5;
  const productDoubleTapDelay = 350;
  const productDoubleTapDistance = 48;
  const productTapMoveTolerance = 12;
  const productTapMaxDuration = 300;
  const productUsesCoarsePointer = window.matchMedia?.("(pointer: coarse)").matches ?? false;
  let productImageZoom = minimumProductZoom;
  let productImagePan = { x: 0, y: 0 };
  let productPanSession = null;
  let productPinchSession = null;
  let productTouchTapCandidate = null;
  let productLastTouchTap = null;
  let productLastTouchDoubleTapTime = Number.NEGATIVE_INFINITY;
  const productTouchPointers = new Map();
  let productLightboxBodyOverflow = "";

  function productLightboxIsOpen() {
    return Boolean(productLightbox && !productLightbox.hidden);
  }

  function higherResolutionProductImage(source) {
    if (!source || source.startsWith("blob:") || source.startsWith("data:")) return source;
    try {
      const url = new URL(source, window.location.href);
      if (url.hostname.includes("shopify") || url.pathname.includes("/cdn/shop/")) {
        url.searchParams.set("width", "2400");
      }
      return url.href;
    } catch (error) {
      return source;
    }
  }

  function clampProductPan(pan, zoom = productImageZoom) {
    if (!productLightboxViewport || zoom <= minimumProductZoom) return { x: 0, y: 0 };
    const maxX = (productLightboxViewport.clientWidth * (zoom - minimumProductZoom)) / 2;
    const maxY = (productLightboxViewport.clientHeight * (zoom - minimumProductZoom)) / 2;
    return {
      x: Math.max(-maxX, Math.min(maxX, pan.x)),
      y: Math.max(-maxY, Math.min(maxY, pan.y)),
    };
  }

  function renderProductImageViewer() {
    if (!productLightboxViewport) return;
    productImagePan = clampProductPan(productImagePan);
    productLightboxViewport.style.setProperty("--image-zoom", String(productImageZoom));
    productLightboxViewport.style.setProperty("--image-pan-x", `${productImagePan.x}px`);
    productLightboxViewport.style.setProperty("--image-pan-y", `${productImagePan.y}px`);
    productLightboxViewport.classList.toggle("is-zoomed", productImageZoom > minimumProductZoom);
    if (productZoomLevel) productZoomLevel.textContent = `${Math.round(productImageZoom * 100)}%`;
    if (productZoomOut) productZoomOut.disabled = productImageZoom <= minimumProductZoom;
    if (productZoomIn) productZoomIn.disabled = productImageZoom >= maximumProductZoom;
    if (productZoomReset) {
      productZoomReset.disabled =
        productImageZoom === minimumProductZoom &&
        productImagePan.x === 0 &&
        productImagePan.y === 0;
    }
    if (productLightboxInstructions) {
      if (productUsesCoarsePointer) {
        productLightboxInstructions.textContent = productImageZoom > minimumProductZoom
          ? "Double-tap to reset · pinch to adjust · drag to move"
          : "Pinch or double-tap to zoom · tap × to close";
      } else {
        productLightboxInstructions.textContent = productImageZoom > minimumProductZoom
          ? "Scroll to zoom · drag to move · Esc closes"
          : "Scroll, double-click, or use − / + to zoom · Esc closes";
      }
    }
  }

  function clampProductZoom(zoom) {
    return Math.min(
      maximumProductZoom,
      Math.max(minimumProductZoom, Math.round(zoom * 1000) / 1000),
    );
  }

  function setProductImageZoom(nextZoom) {
    productImageZoom = clampProductZoom(nextZoom);
    if (productImageZoom === minimumProductZoom) {
      productImagePan = { x: 0, y: 0 };
      productPanSession = null;
      productLightboxViewport?.classList.remove("is-panning");
    }
    renderProductImageViewer();
  }

  function clearProductPointerSessions() {
    const capturedPointers = new Set(productTouchPointers.keys());
    if (productPanSession) capturedPointers.add(productPanSession.pointerId);
    productTouchPointers.clear();
    productPanSession = null;
    productPinchSession = null;
    productTouchTapCandidate = null;
    productLastTouchTap = null;
    if (productLightboxViewport) {
      productLightboxViewport.classList.remove("is-panning", "is-pinching");
      capturedPointers.forEach((pointerId) => {
        if (productLightboxViewport.hasPointerCapture(pointerId)) {
          productLightboxViewport.releasePointerCapture(pointerId);
        }
      });
    }
  }

  function resetProductImageViewer() {
    productImageZoom = minimumProductZoom;
    productImagePan = { x: 0, y: 0 };
    clearProductPointerSessions();
    renderProductImageViewer();
  }

  function openProductImageViewer() {
    if (!productLightbox || !productLightboxImage) return;
    const currentImage = productPage?.querySelector("[data-vl-product-image]");
    if (currentImage) {
      productLightboxImage.src = higherResolutionProductImage(currentImage.currentSrc || currentImage.src);
      productLightboxImage.alt = currentImage.alt;
    }
    resetProductImageViewer();
    productLightboxBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    root.classList.add("vl-product-lightbox-open");
    productLightbox.hidden = false;
    productImageTrigger?.setAttribute("aria-expanded", "true");
    window.requestAnimationFrame(() => {
      productLightbox.querySelector("[data-vl-product-lightbox-close]")?.focus();
    });
  }

  function closeProductImageViewer() {
    if (!productLightboxIsOpen()) return;
    productLightbox.hidden = true;
    document.body.style.overflow = productLightboxBodyOverflow;
    root.classList.remove("vl-product-lightbox-open");
    productImageTrigger?.setAttribute("aria-expanded", "false");
    resetProductImageViewer();
    window.requestAnimationFrame(() => productImageTrigger?.focus());
  }

  productImageTrigger?.addEventListener("click", openProductImageViewer);
  productLightbox?.querySelector("[data-vl-product-lightbox-close]")?.addEventListener("click", closeProductImageViewer);
  productLightbox?.addEventListener("click", (event) => {
    if (event.target === productLightbox) closeProductImageViewer();
  });
  productZoomOut?.addEventListener("click", () => setProductImageZoom(productImageZoom - productZoomStep));
  productZoomIn?.addEventListener("click", () => setProductImageZoom(productImageZoom + productZoomStep));
  productZoomReset?.addEventListener("click", resetProductImageViewer);
  productLightboxViewport?.addEventListener("wheel", (event) => {
    event.preventDefault();
    setProductImageZoom(productImageZoom + (event.deltaY < 0 ? 0.25 : -0.25));
  }, { passive: false });

  function toggleProductImageZoomAt(clientX, clientY) {
    if (!productLightboxViewport) return;
    if (productImageZoom > minimumProductZoom) {
      resetProductImageViewer();
      return;
    }

    const nextZoom = 2;
    const rect = productLightboxViewport.getBoundingClientRect();
    const offsetX = clientX - rect.left - rect.width / 2;
    const offsetY = clientY - rect.top - rect.height / 2;
    productImageZoom = nextZoom;
    productImagePan = clampProductPan({
      x: -offsetX * (nextZoom - minimumProductZoom),
      y: -offsetY * (nextZoom - minimumProductZoom),
    }, nextZoom);
    renderProductImageViewer();
  }

  productLightboxViewport?.addEventListener("dblclick", (event) => {
    event.preventDefault();
    if (performance.now() - productLastTouchDoubleTapTime < 500) return;
    toggleProductImageZoomAt(event.clientX, event.clientY);
  });

  function startProductImagePan(pointerId, clientX, clientY) {
    if (productImageZoom <= minimumProductZoom) return;
    productPanSession = {
      pointerId,
      startX: clientX,
      startY: clientY,
      originX: productImagePan.x,
      originY: productImagePan.y,
    };
    productLightboxViewport?.classList.add("is-panning");
  }

  function productPinchPoints() {
    if (!productPinchSession) return [];
    return productPinchSession.pointerIds
      .map((pointerId) => productTouchPointers.get(pointerId))
      .filter(Boolean);
  }

  function startProductImagePinch() {
    if (!productLightboxViewport || productTouchPointers.size < 2) return;
    productTouchTapCandidate = null;
    productLastTouchTap = null;
    const pointerEntries = [...productTouchPointers.entries()].slice(0, 2);
    const [first, second] = pointerEntries.map(([, point]) => point);
    const distance = Math.hypot(second.x - first.x, second.y - first.y);
    if (distance < 1) return;
    const rect = productLightboxViewport.getBoundingClientRect();
    const midpoint = {
      x: (first.x + second.x) / 2 - rect.left - rect.width / 2,
      y: (first.y + second.y) / 2 - rect.top - rect.height / 2,
    };
    productPinchSession = {
      pointerIds: pointerEntries.map(([pointerId]) => pointerId),
      startDistance: distance,
      startZoom: productImageZoom,
      anchorX: (midpoint.x - productImagePan.x) / productImageZoom,
      anchorY: (midpoint.y - productImagePan.y) / productImageZoom,
    };
    productPanSession = null;
    productLightboxViewport.classList.remove("is-panning");
    productLightboxViewport.classList.add("is-pinching");
  }

  function updateProductImagePinch() {
    if (!productLightboxViewport || !productPinchSession) return;
    const [first, second] = productPinchPoints();
    if (!first || !second) return;
    const distance = Math.hypot(second.x - first.x, second.y - first.y);
    if (distance < 1) return;
    const rect = productLightboxViewport.getBoundingClientRect();
    const midpoint = {
      x: (first.x + second.x) / 2 - rect.left - rect.width / 2,
      y: (first.y + second.y) / 2 - rect.top - rect.height / 2,
    };
    const nextZoom = clampProductZoom(
      productPinchSession.startZoom * (distance / productPinchSession.startDistance),
    );
    productImageZoom = nextZoom;
    productImagePan = clampProductPan({
      x: midpoint.x - productPinchSession.anchorX * nextZoom,
      y: midpoint.y - productPinchSession.anchorY * nextZoom,
    }, nextZoom);
    renderProductImageViewer();
  }

  productLightboxViewport?.addEventListener("pointerdown", (event) => {
    if (event.pointerType === "mouse" && event.button !== 0) return;
    if (event.pointerType === "touch") {
      event.preventDefault();
      if (productTouchPointers.size === 0) {
        productTouchTapCandidate = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          startTime: performance.now(),
        };
      } else {
        productTouchTapCandidate = null;
        productLastTouchTap = null;
      }
      productLightboxViewport.setPointerCapture(event.pointerId);
      productTouchPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (productTouchPointers.size >= 2) {
        startProductImagePinch();
      } else {
        startProductImagePan(event.pointerId, event.clientX, event.clientY);
      }
      return;
    }
    if (productImageZoom <= minimumProductZoom) return;
    event.preventDefault();
    productLightboxViewport.setPointerCapture(event.pointerId);
    startProductImagePan(event.pointerId, event.clientX, event.clientY);
  });
  productLightboxViewport?.addEventListener("pointermove", (event) => {
    if (productTouchPointers.has(event.pointerId)) {
      event.preventDefault();
      productTouchPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (
        productTouchTapCandidate?.pointerId === event.pointerId &&
        Math.hypot(
          event.clientX - productTouchTapCandidate.startX,
          event.clientY - productTouchTapCandidate.startY,
        ) > productTapMoveTolerance
      ) {
        productTouchTapCandidate = null;
      }
      if (productPinchSession) {
        updateProductImagePinch();
        return;
      }
    }
    if (!productPanSession || productPanSession.pointerId !== event.pointerId) return;
    event.preventDefault();
    productImagePan = clampProductPan({
      x: productPanSession.originX + event.clientX - productPanSession.startX,
      y: productPanSession.originY + event.clientY - productPanSession.startY,
    });
    renderProductImageViewer();
  });

  function finishProductImagePointer(event) {
    const finishedAt = performance.now();
    const isTouchTap = Boolean(
      event.type === "pointerup" &&
      productTouchTapCandidate?.pointerId === event.pointerId &&
      productTouchPointers.size === 1 &&
      !productPinchSession &&
      finishedAt - productTouchTapCandidate.startTime <= productTapMaxDuration
    );
    const tapPoint = isTouchTap ? { x: event.clientX, y: event.clientY } : null;
    if (productTouchTapCandidate?.pointerId === event.pointerId) {
      productTouchTapCandidate = null;
    }
    const wasTouchPointer = productTouchPointers.delete(event.pointerId);
    if (productPanSession?.pointerId === event.pointerId) {
      productPanSession = null;
      productLightboxViewport?.classList.remove("is-panning");
    }
    if (productPinchSession?.pointerIds.includes(event.pointerId)) {
      productPinchSession = null;
      productLightboxViewport?.classList.remove("is-pinching");
    }
    if (productLightboxViewport?.hasPointerCapture(event.pointerId)) {
      productLightboxViewport.releasePointerCapture(event.pointerId);
    }
    if (!wasTouchPointer) return;
    if (tapPoint) {
      const isDoubleTap = Boolean(
        productLastTouchTap &&
        finishedAt - productLastTouchTap.time <= productDoubleTapDelay &&
        Math.hypot(tapPoint.x - productLastTouchTap.x, tapPoint.y - productLastTouchTap.y) <=
          productDoubleTapDistance
      );
      if (isDoubleTap) {
        productLastTouchTap = null;
        productLastTouchDoubleTapTime = finishedAt;
        toggleProductImageZoomAt(tapPoint.x, tapPoint.y);
      } else {
        productLastTouchTap = { x: tapPoint.x, y: tapPoint.y, time: finishedAt };
      }
    }
    if (productTouchPointers.size >= 2) {
      startProductImagePinch();
      return;
    }
    const remainingPointer = productTouchPointers.entries().next().value;
    if (remainingPointer && productImageZoom > minimumProductZoom) {
      const [pointerId, point] = remainingPointer;
      startProductImagePan(pointerId, point.x, point.y);
    }
  }

  productLightboxViewport?.addEventListener("pointerup", finishProductImagePointer);
  productLightboxViewport?.addEventListener("pointercancel", finishProductImagePointer);
  productLightboxViewport?.addEventListener("lostpointercapture", (event) => {
    if (productTouchPointers.has(event.pointerId) || productPanSession?.pointerId === event.pointerId) {
      finishProductImagePointer(event);
    }
  });
  window.addEventListener("resize", () => {
    if (productLightboxIsOpen()) renderProductImageViewer();
  });
  document.addEventListener("keydown", (event) => {
    if (!productLightboxIsOpen()) return;
    if (event.key === "Escape") {
      closeProductImageViewer();
      return;
    }
    if (event.key === "+" || event.key === "=") {
      event.preventDefault();
      setProductImageZoom(productImageZoom + productZoomStep);
      return;
    }
    if (event.key === "-" || event.key === "_") {
      event.preventDefault();
      setProductImageZoom(productImageZoom - productZoomStep);
      return;
    }
    if (event.key === "0") {
      event.preventDefault();
      resetProductImageViewer();
      return;
    }
    if (productImageZoom <= minimumProductZoom) return;
    const panStep = 54;
    const arrowPan = {
      ArrowLeft: { x: panStep, y: 0 },
      ArrowRight: { x: -panStep, y: 0 },
      ArrowUp: { x: 0, y: panStep },
      ArrowDown: { x: 0, y: -panStep },
    }[event.key];
    if (!arrowPan) return;
    event.preventDefault();
    productImagePan = clampProductPan({
      x: productImagePan.x + arrowPan.x,
      y: productImagePan.y + arrowPan.y,
    });
    renderProductImageViewer();
  });
  resetProductImageViewer();

  if (capPicker && variantControl?.tagName === "SELECT") {
    const capVariantScript = capPicker.querySelector("[data-vl-cap-variants]");
    const capNativeField = productForm.querySelector("[data-vl-cap-native-field]");
    const capColorButtons = [...capPicker.querySelectorAll("[data-vl-cap-color]")];
    const capFitButtons = [...capPicker.querySelectorAll("[data-vl-cap-fit]")];
    const capPackButtons = [...capPicker.querySelectorAll("[data-vl-cap-pack]")];
    const capColorLabel = capPicker.querySelector("[data-vl-cap-color-label]");
    const capSelection = capPicker.querySelector("[data-vl-cap-selection]");
    const capAvailability = capPicker.querySelector("[data-vl-cap-availability]");

    let capVariantRecords = [];
    try {
      capVariantRecords = JSON.parse(capVariantScript?.textContent || "[]").map((variant) => {
        const size = String(variant.size || "");
        const fit = size.includes(" + ") ? "mixed" : size.includes("Large") ? "large" : "small";
        const pack = fit === "mixed" ? "10+10" : size.trim().split(/\s+/)[0];
        return {
          ...variant,
          id: Number(variant.id),
          fit,
          pack,
          legacy: fit === "large" && pack === "20" && /\)\s+10\s*$/.test(size),
        };
      });
    } catch (error) {
      capVariantRecords = [];
    }

    if (capVariantRecords.length) {
      const selectedCapVariant =
        capVariantRecords.find((variant) => String(variant.id) === variantControl.value) ||
        capVariantRecords.find((variant) => variant.available) ||
        capVariantRecords[0];
      const capState = {
        color: selectedCapVariant.color,
        fit: selectedCapVariant.fit,
        pack: selectedCapVariant.pack,
      };
      const capFitOrder = ["small", "large", "mixed"];
      const capPackOrder = ["10", "20", "4", "1", "50", "100", "10+10"];

      const matchingCaps = (filters, availableOnly = false) =>
        capVariantRecords.filter((variant) => {
          if (availableOnly && !variant.available) return false;
          return Object.entries(filters).every(([key, value]) => variant[key] === value);
        });

      const preferredCapVariant = (records) =>
        records.find((variant) => variant.available && !variant.legacy) ||
        records.find((variant) => variant.available) ||
        records.find((variant) => !variant.legacy) ||
        records[0];

      function normalizeCapState() {
        const availableCaps = capVariantRecords.filter((variant) => variant.available);
        if (!availableCaps.length) return null;

        if (!matchingCaps({ color: capState.color }, true).length) {
          capState.color = availableCaps[0].color;
        }

        if (!matchingCaps({ color: capState.color, fit: capState.fit }, true).length) {
          capState.fit =
            capFitOrder.find((fit) => matchingCaps({ color: capState.color, fit }, true).length) ||
            matchingCaps({ color: capState.color }, true)[0].fit;
        }

        if (!matchingCaps({ color: capState.color, fit: capState.fit, pack: capState.pack }, true).length) {
          capState.pack =
            capPackOrder.find(
              (pack) => matchingCaps({ color: capState.color, fit: capState.fit, pack }, true).length,
            ) || matchingCaps({ color: capState.color, fit: capState.fit }, true)[0].pack;
        }

        return preferredCapVariant(
          matchingCaps({ color: capState.color, fit: capState.fit, pack: capState.pack }),
        );
      }

      function renderCapPicker(syncVariant = true) {
        const chosenVariant = normalizeCapState();
        if (!chosenVariant) return;

        capColorButtons.forEach((button) => {
          const color = button.dataset.vlCapColor;
          const isSelected = color === capState.color;
          button.disabled = !matchingCaps({ color }, true).length;
          button.classList.toggle("is-selected", isSelected);
          button.setAttribute("aria-pressed", String(isSelected));
        });

        capFitButtons.forEach((button) => {
          const fit = button.dataset.vlCapFit;
          const isSelected = fit === capState.fit;
          button.disabled = !matchingCaps({ color: capState.color, fit }, true).length;
          button.classList.toggle("is-selected", isSelected);
          button.setAttribute("aria-pressed", String(isSelected));
        });

        capPackButtons.forEach((button) => {
          const pack = button.dataset.vlCapPack;
          const existing = matchingCaps({ color: capState.color, fit: capState.fit, pack });
          const belongsToFit = capState.fit === "mixed" ? pack === "10+10" : pack !== "10+10";
          const isAvailable = existing.some((variant) => variant.available);
          const isSelected = pack === capState.pack;
          const packLabel = pack === "10+10" ? "10 small + 10 large" : `${pack}-pack`;
          button.hidden = !belongsToFit;
          button.disabled = belongsToFit && !isAvailable;
          button.toggleAttribute("data-vl-cap-unavailable", belongsToFit && !isAvailable);
          button.setAttribute(
            "aria-label",
            isAvailable
              ? packLabel
              : `${packLabel} is not available in ${capState.color} ${capState.fit} caps`,
          );
          if (isAvailable) {
            button.removeAttribute("title");
          } else if (belongsToFit) {
            button.title = `${packLabel} is not available in ${capState.color}`;
          }
          button.classList.toggle("is-selected", isSelected);
          button.setAttribute("aria-pressed", String(isSelected));
        });

        if (capColorLabel) capColorLabel.textContent = capState.color;
        if (capSelection) {
          const fitLabel =
            capState.fit === "small"
              ? "Small · 3mL case fit"
              : capState.fit === "large"
                ? "Large · 10mL case fit"
                : "Mixed fit";
          const packLabel = capState.pack === "10+10" ? "10 small + 10 large" : `${capState.pack}-pack`;
          capSelection.textContent = `${capState.color} · ${fitLabel} · ${packLabel}`;
        }
        if (capAvailability) {
          const unavailableCount = capPackButtons.filter(
            (button) => !button.hidden && button.disabled,
          ).length;
          capAvailability.textContent = unavailableCount
            ? `Unavailable ${capState.color} pack sizes are shown but disabled.`
            : `All shown ${capState.color} pack sizes are available.`;
        }

        if (syncVariant && variantControl.value !== String(chosenVariant.id)) {
          variantControl.value = String(chosenVariant.id);
          variantControl.dispatchEvent(new window.Event("change", { bubbles: true }));
        }
      }

      capColorButtons.forEach((button) => {
        button.addEventListener("click", () => {
          capState.color = button.dataset.vlCapColor;
          renderCapPicker();
        });
      });
      capFitButtons.forEach((button) => {
        button.addEventListener("click", () => {
          capState.fit = button.dataset.vlCapFit;
          renderCapPicker();
        });
      });
      capPackButtons.forEach((button) => {
        button.addEventListener("click", () => {
          capState.pack = button.dataset.vlCapPack;
          renderCapPicker();
        });
      });

      capNativeField?.classList.add("is-enhanced");
      variantControl.setAttribute("aria-hidden", "true");
      variantControl.setAttribute("tabindex", "-1");
      renderCapPicker();
    }
  }

  if (casePicker && variantControl?.tagName === "SELECT") {
    const caseVariantScript = casePicker.querySelector("[data-vl-case-variants]");
    const caseColorButtons = [...casePicker.querySelectorAll("[data-vl-case-color]")];
    const caseColorLabel = casePicker.querySelector("[data-vl-case-color-label]");
    const caseSelection = casePicker.querySelector("[data-vl-case-selection]");
    const caseNativeField = productForm.querySelector("[data-vl-case-native-field]");
    let caseVariantRecords = [];

    try {
      caseVariantRecords = JSON.parse(caseVariantScript?.textContent || "[]").map((variant) => ({
        ...variant,
        id: Number(variant.id),
      }));
    } catch (error) {
      caseVariantRecords = [];
    }

    if (caseVariantRecords.length) {
      const selectedCaseVariant =
        caseVariantRecords.find((variant) => String(variant.id) === variantControl.value) ||
        caseVariantRecords.find((variant) => variant.available) ||
        caseVariantRecords[0];
      const caseState = { color: selectedCaseVariant.color };

      function renderCasePicker(syncVariant = true) {
        const matchingVariants = caseVariantRecords.filter((variant) => variant.color === caseState.color);
        const chosenVariant =
          matchingVariants.find((variant) => variant.available) ||
          matchingVariants[0] ||
          caseVariantRecords.find((variant) => variant.available) ||
          caseVariantRecords[0];
        if (!chosenVariant) return;
        caseState.color = chosenVariant.color;

        caseColorButtons.forEach((button) => {
          const color = button.dataset.vlCaseColor;
          const isAvailable = caseVariantRecords.some(
            (variant) => variant.color === color && variant.available,
          );
          const isSelected = color === caseState.color;
          button.disabled = !isAvailable;
          button.classList.toggle("is-selected", isSelected);
          button.setAttribute("aria-pressed", String(isSelected));
        });

        if (caseColorLabel) caseColorLabel.textContent = caseState.color;
        if (caseSelection) caseSelection.textContent = `${caseState.color} selected`;

        if (syncVariant && variantControl.value !== String(chosenVariant.id)) {
          variantControl.value = String(chosenVariant.id);
          variantControl.dispatchEvent(new window.Event("change", { bubbles: true }));
        }
      }

      caseColorButtons.forEach((button) => {
        button.addEventListener("click", () => {
          caseState.color = button.dataset.vlCaseColor;
          renderCasePicker();
        });
      });

      variantControl.addEventListener("change", () => {
        const selectedRecord = caseVariantRecords.find(
          (variant) => String(variant.id) === variantControl.value,
        );
        if (selectedRecord) {
          caseState.color = selectedRecord.color;
          renderCasePicker(false);
        }
      });

      if (casePicker.dataset.hideNative === "true") {
        caseNativeField?.classList.add("is-enhanced");
        variantControl.setAttribute("aria-hidden", "true");
        variantControl.setAttribute("tabindex", "-1");
      }
      renderCasePicker();
    }
  }

  const colorPreviewCache = new Map();
  let productImageRequest = 0;

  function loadPreviewImage(source) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.decoding = "async";
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error("The selected-color preview could not be loaded."));
      image.src = source;
    });
  }

  function rgbToHueSaturation(red, green, blue) {
    const r = red / 255;
    const g = green / 255;
    const b = blue / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    const delta = max - min;
    let hue = 0;
    if (delta) {
      if (max === r) hue = 60 * (((g - b) / delta) % 6);
      else if (max === g) hue = 60 * ((b - r) / delta + 2);
      else hue = 60 * ((r - g) / delta + 4);
    }
    if (hue < 0) hue += 360;
    return { hue, saturation: max ? delta / max : 0, value: max };
  }

  function selectedColorTarget(color, value) {
    const shade = Math.max(0.44, Math.min(1.08, 0.48 + value * 0.66));
    const targets = {
      Black: [24, 22, 29],
      Blue: [47, 88, 197],
      Pink: [252, 158, 190],
      Red: [206, 45, 58],
      White: [238, 236, 230],
      Yellow: [236, 202, 38],
      "Solid Pink": [238, 79, 137],
      "Translucent Pink": [245, 132, 171],
    };
    const target = targets[color] || [95, 56, 144];
    if (color === "White") {
      const white = Math.round(218 + value * 34);
      return [white, white, Math.max(212, white - 4)];
    }
    if (color === "Black") {
      const blackShade = Math.round(12 + value * 42);
      return [blackShade, blackShade, blackShade + 4];
    }
    return target.map((channel) => Math.max(0, Math.min(255, Math.round(channel * shade))));
  }

  async function createSelectedColorPreview(source, color) {
    const cacheKey = `${source}::${color}`;
    if (colorPreviewCache.has(cacheKey)) return colorPreviewCache.get(cacheKey);

    const sourceImage = await loadPreviewImage(source);
    const maxWidth = 1400;
    const scale = Math.min(1, maxWidth / sourceImage.naturalWidth);
    const canvas = document.createElement("canvas");
    canvas.width = Math.max(1, Math.round(sourceImage.naturalWidth * scale));
    canvas.height = Math.max(1, Math.round(sourceImage.naturalHeight * scale));
    const context = canvas.getContext("2d", { willReadFrequently: true });
    context.drawImage(sourceImage, 0, 0, canvas.width, canvas.height);
    const frame = context.getImageData(0, 0, canvas.width, canvas.height);
    const pixels = frame.data;

    for (let index = 0; index < pixels.length; index += 4) {
      const red = pixels[index];
      const green = pixels[index + 1];
      const blue = pixels[index + 2];
      const { hue, saturation, value } = rgbToHueSaturation(red, green, blue);
      const isProductColor = saturation > 0.17 && (hue >= 178 || hue <= 24);
      if (!isProductColor) continue;
      const colorStrength = Math.min(1, Math.max(0, (saturation - 0.17) / 0.34));
      const [targetRed, targetGreen, targetBlue] = selectedColorTarget(color, value);
      const blend = color === "Translucent Pink" ? colorStrength * 0.68 : colorStrength * 0.94;
      pixels[index] = Math.round(red * (1 - blend) + targetRed * blend);
      pixels[index + 1] = Math.round(green * (1 - blend) + targetGreen * blend);
      pixels[index + 2] = Math.round(blue * (1 - blend) + targetBlue * blend);
    }

    context.putImageData(frame, 0, 0);
    const previewUrl = await new Promise((resolve) => {
      canvas.toBlob(
        (blob) => resolve(blob ? URL.createObjectURL(blob) : canvas.toDataURL("image/jpeg", 0.9)),
        "image/jpeg",
        0.9,
      );
    });
    colorPreviewCache.set(cacheKey, previewUrl);
    return previewUrl;
  }

  function selectedVariantData() {
    if (!variantControl) return null;
    if (variantControl.tagName === "SELECT") {
      const option = variantControl.selectedOptions?.[0];
      return option
        ? {
            id: Number(option.value),
            price: Number(option.dataset.price || 0),
            money: option.dataset.money,
            image: option.dataset.image,
            imageMode: option.dataset.imageMode || "exact",
            color: option.dataset.color || "",
            alt: option.dataset.alt || "",
            available: !option.disabled,
            quantityMin: Number(option.dataset.quantityMin || 1),
            quantityStep: Number(option.dataset.quantityStep || 1),
            quantityMax: option.dataset.quantityMax ? Number(option.dataset.quantityMax) : null,
          }
        : null;
    }
    return {
      id: Number(variantControl.value),
      price: Number(variantControl.dataset.price || 0),
      money: variantControl.dataset.money,
      image: variantControl.dataset.image || primaryProductButton?.dataset.vlAddImage,
      imageMode: variantControl.dataset.imageMode || "exact",
      color: variantControl.dataset.color || "",
      alt: variantControl.dataset.alt || "",
      available: !primaryProductButton?.disabled,
      quantityMin: Number(variantControl.dataset.quantityMin || 1),
      quantityStep: Number(variantControl.dataset.quantityStep || 1),
      quantityMax: variantControl.dataset.quantityMax ? Number(variantControl.dataset.quantityMax) : null,
    };
  }

  function productQuantityRules(variant = selectedVariantData()) {
    const min = Math.max(1, Number(variant?.quantityMin || productQuantityInput?.min || 1));
    const step = Math.max(1, Number(variant?.quantityStep || productQuantityInput?.step || 1));
    const rawMax = variant?.quantityMax ?? productQuantityInput?.max;
    const parsedMax = rawMax === "" || rawMax == null ? null : Number(rawMax);
    const max = Number.isFinite(parsedMax) && parsedMax >= min ? parsedMax : null;
    return { min, step, max };
  }

  function selectedProductQuantity({ commit = false } = {}) {
    const { min, step, max } = productQuantityRules();
    let quantity = Number.parseInt(productQuantityInput?.value || "", 10);
    if (!Number.isFinite(quantity)) quantity = min;
    quantity = Math.max(min, quantity);
    if (max != null) quantity = Math.min(max, quantity);
    const stepOffset = quantity - min;
    if (stepOffset % step !== 0) {
      quantity = min + Math.round(stepOffset / step) * step;
      quantity = Math.max(min, quantity);
      if (max != null) quantity = Math.min(max, quantity);
    }
    if (commit && productQuantityInput) productQuantityInput.value = String(quantity);
    if (productQuantityInput) productQuantityInput.setAttribute("aria-valuenow", String(quantity));
    if (productQuantityMinus) productQuantityMinus.disabled = quantity <= min;
    if (productQuantityPlus) productQuantityPlus.disabled = max != null && quantity >= max;
    return quantity;
  }

  function updateProductQuantityRules(variant) {
    if (!productQuantityInput) return;
    const { min, step, max } = productQuantityRules(variant);
    productQuantityInput.min = String(min);
    productQuantityInput.step = String(step);
    productQuantityInput.setAttribute("aria-valuemin", String(min));
    if (max == null) {
      productQuantityInput.removeAttribute("max");
      productQuantityInput.removeAttribute("aria-valuemax");
    } else {
      productQuantityInput.max = String(max);
      productQuantityInput.setAttribute("aria-valuemax", String(max));
    }
    selectedProductQuantity({ commit: true });
  }

  function adjustProductQuantity(direction) {
    if (!productQuantityInput) return;
    const { min, step, max } = productQuantityRules();
    let quantity = selectedProductQuantity({ commit: true }) + direction * step;
    quantity = Math.max(min, quantity);
    if (max != null) quantity = Math.min(max, quantity);
    productQuantityInput.value = String(quantity);
    updateProductPurchase();
    productQuantityInput.focus();
  }

  function swatchBackground(color) {
    const swatches = {
      Black: "#1d1a22",
      Blue: "#315ec9",
      Green: "#82bf45",
      Pink: "#e99ab8",
      Purple: "#7b4dc4",
      Red: "#d93445",
      "Solid Pink": "#f45b93",
      "Translucent Pink":
        "linear-gradient(45deg, rgba(244,91,147,.55) 0 50%, rgba(255,255,255,.9) 50% 100%)",
      White: "#f7f5ef",
      Yellow: "#f0cf37",
      Mix:
        "conic-gradient(#f45b93 0 14%, #82bf45 14% 28%, #f0cf37 28% 42%, #4d6bd8 42% 56%, #7b4dc4 56% 70%, #1d1a22 70% 84%, #f6f3ed 84% 100%)",
      "RGB Metallic Blue/Magenta":
        "linear-gradient(135deg, #2157cb 0%, #6842c2 48%, #dc3f9f 100%)",
    };
    return swatches[color] || "#5f3890";
  }

  async function updateProductImage(variant) {
    const productImage = productPage?.querySelector("[data-vl-product-image]");
    if (!productImage || !variant.image) return;
    const requestId = ++productImageRequest;
    const figure = productPage.querySelector("[data-vl-product-figure]");
    const colorStatus = productPage.querySelector("[data-vl-selected-color]");
    const colorStatusLabel = productPage.querySelector("[data-vl-selected-color-label]");
    const colorStatusSwatch = productPage.querySelector("[data-vl-selected-color-swatch]");
    figure?.classList.add("is-switching");

    let resolvedImage = variant.image;
    if (variant.imageMode === "tint" && variant.color) {
      try {
        resolvedImage = await createSelectedColorPreview(variant.image, variant.color);
      } catch (error) {
        resolvedImage = variant.image;
      }
    }
    if (requestId !== productImageRequest) return;

    productImage.removeAttribute("srcset");
    productImage.removeAttribute("sizes");
    productImage.src = resolvedImage;
    if (variant.alt) productImage.alt = variant.alt;
    if (primaryProductButton) primaryProductButton.dataset.vlAddImage = resolvedImage;

    if (variant.color) {
      colorStatus.hidden = false;
      colorStatusLabel.textContent = variant.color;
      colorStatusSwatch.style.background = swatchBackground(variant.color);
    } else {
      colorStatus.hidden = true;
    }

    requestAnimationFrame(() => figure?.classList.remove("is-switching"));
  }

  function setLogoFieldsEnabled() {
    if (!logoOption) return;
    const selected = Boolean(logoToggle?.checked);
    logoOption.classList.toggle("selected", selected);
    if (logoFields) logoFields.hidden = !selected;
    [logoFile, logoInstructions, logoRights, logoProperty, logoGroup].forEach((field) => {
      if (field) field.disabled = !selected;
    });
    if (logoFile) logoFile.required = selected;
    if (logoRights) logoRights.required = selected;
    if (!selected) {
      logoFile?.setCustomValidity("");
      logoRights?.setCustomValidity("");
      if (logoFileStatus) {
        logoFileStatus.textContent = "SVG, PDF, or transparent PNG preferred · 20 MB maximum";
        logoFileStatus.classList.remove("error");
      }
    }
  }

  function validateLogoSelection() {
    if (!logoToggle?.checked) return true;
    const file = logoFile?.files?.[0];
    if (!file) {
      logoFile?.setCustomValidity("Choose the logo artwork you want printed.");
      logoFile?.reportValidity();
      return false;
    }
    if (file.size > logoMaximumBytes) {
      logoFile?.setCustomValidity("Logo files must be 20 MB or smaller.");
      if (logoFileStatus) {
        logoFileStatus.textContent = "This file is larger than 20 MB. Choose a smaller file.";
        logoFileStatus.classList.add("error");
      }
      logoFile?.reportValidity();
      return false;
    }
    logoFile?.setCustomValidity("");
    if (!logoRights?.checked) {
      logoRights?.setCustomValidity("Confirm that you own or have permission to print this artwork.");
      logoRights?.reportValidity();
      return false;
    }
    logoRights?.setCustomValidity("");
    return true;
  }

  function newLogoGroupId() {
    const random = window.crypto?.randomUUID?.() || Math.random().toString(36).slice(2);
    return `vl-logo-${Date.now().toString(36)}-${random}`;
  }

  async function addProductWithLogo({ variant, quantity, selectedCaps, source, image }) {
    const logoVariantId = Number(logoOption?.dataset.logoVariant || 0);
    if (!logoVariantId) throw new Error("Custom logo printing is temporarily unavailable.");

    const groupId = newLogoGroupId();
    if (logoGroup) logoGroup.value = groupId;
    const formData = new FormData(productForm);
    formData.set("id", String(variant.id));
    formData.set("quantity", String(quantity));
    const cartFlight = flyToCart(source, image);

    const mainResponse = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData,
    });
    const mainItem = await mainResponse.json().catch(() => ({}));
    if (!mainResponse.ok) {
      throw new Error(mainItem.description || "The case and logo artwork could not be added.");
    }

    const companionItems = [{
      id: logoVariantId,
      quantity,
      properties: {
        _vl_logo_group: groupId,
        _vl_logo_addon: "true",
        "Applied to": String(productPage?.dataset.shopifyTitle || "VialLock case").split("|")[0].trim(),
      },
    }];
    if (selectedCaps) companionItems.push({ id: selectedCaps.id, quantity: 1 });

    const companionResponse = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: companionItems }),
    });
    if (!companionResponse.ok) {
      if (mainItem.key) {
        await fetch(`${window.Shopify?.routes?.root || "/"}cart/change.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: mainItem.key, quantity: 0 }),
        }).catch(() => {});
      }
      const problem = await companionResponse.json().catch(() => ({}));
      throw new Error(problem.description || "The custom logo charge could not be added. Your bag was not changed.");
    }

    document.dispatchEvent(new CustomEvent("vl:cart:add", { detail: { items: companionItems } }));
    renderCart(await fetchCart());
    await cartFlight;
    openCart();
  }

  function updateProductPurchase() {
    if (!productForm) return;
    const variant = selectedVariantData();
    if (!variant) return;
    updateProductQuantityRules(variant);
    const quantity = selectedProductQuantity();
    const includeCaps = Boolean(capControl?.checked);
    const includeLogo = Boolean(logoToggle?.checked);
    const selectedCaps = selectedQuickCapVariant(productCapPicker);
    const capPrice = Number(selectedCaps?.price || capControl?.dataset.capPrice || 0);
    const logoPrice = Number(logoOption?.dataset.logoPrice || 0);
    const total = variant.price * quantity + (includeCaps ? capPrice : 0) + (includeLogo ? logoPrice * quantity : 0);
    const panelPrice = productPage.querySelector("[data-vl-product-price]");
    if (panelPrice) panelPrice.textContent = variant.money || moneyFromCents(variant.price);
    const totalLabel = productPage.querySelector("[data-vl-product-total-label]");
    if (totalLabel) {
      totalLabel.textContent = includeLogo && includeCaps
        ? "Case + logo + caps"
        : includeLogo
          ? "Case + custom logo"
          : includeCaps
            ? "Case + caps"
            : "Product total";
    }
    productPage.querySelectorAll("[data-vl-product-total], [data-vl-product-button-price], [data-vl-sticky-price]").forEach((node) => {
      node.textContent = moneyFromCents(total);
    });
    productPage.querySelector("[data-vl-product-cap-offer]")?.classList.toggle("selected", includeCaps);
    setLogoFieldsEnabled();
    if (primaryProductButton) primaryProductButton.disabled = !variant.available;
    updateProductImage(variant);
  }

  variantControl?.addEventListener("change", updateProductPurchase);
  capControl?.addEventListener("change", updateProductPurchase);
  logoToggle?.addEventListener("change", updateProductPurchase);
  logoFile?.addEventListener("change", () => {
    const file = logoFile.files?.[0];
    logoFile.setCustomValidity("");
    if (!logoFileStatus) return;
    if (!file) {
      logoFileStatus.textContent = "SVG, PDF, or transparent PNG preferred · 20 MB maximum";
      logoFileStatus.classList.remove("error");
    } else if (file.size > logoMaximumBytes) {
      logoFileStatus.textContent = "This file is larger than 20 MB. Choose a smaller file.";
      logoFileStatus.classList.add("error");
    } else {
      logoFileStatus.textContent = `${file.name} · ${(file.size / 1024 / 1024).toFixed(1)} MB`;
      logoFileStatus.classList.remove("error");
    }
  });
  logoRights?.addEventListener("change", () => logoRights.setCustomValidity(""));
  productCapPicker?.addEventListener("vl:cap-selection-change", updateProductPurchase);
  productQuantityInput?.addEventListener("focus", () => {
    productQuantityInput.dataset.vlReplaceOnType = "true";
    productQuantityInput.select();
  });
  productQuantityInput?.addEventListener("click", () => {
    productQuantityInput.dataset.vlReplaceOnType = "true";
    productQuantityInput.select();
  });
  productQuantityInput?.addEventListener("keydown", (event) => {
    const replacesCurrentValue =
      productQuantityInput.dataset.vlReplaceOnType === "true" &&
      /^\d$/.test(event.key || "");
    if (!replacesCurrentValue) return;
    event.preventDefault();
    productQuantityInput.value = event.key;
    delete productQuantityInput.dataset.vlReplaceOnType;
    productQuantityInput.dispatchEvent(new Event("input", { bubbles: true }));
  });
  productQuantityInput?.addEventListener("beforeinput", (event) => {
    const replacesCurrentValue =
      productQuantityInput.dataset.vlReplaceOnType === "true" &&
      event.inputType?.startsWith("insert") &&
      /^\d+$/.test(event.data || "");
    if (!replacesCurrentValue) return;
    event.preventDefault();
    productQuantityInput.value = event.data;
    delete productQuantityInput.dataset.vlReplaceOnType;
    productQuantityInput.dispatchEvent(new Event("input", { bubbles: true }));
  });
  productQuantityInput?.addEventListener("input", () => {
    delete productQuantityInput.dataset.vlReplaceOnType;
    updateProductPurchase();
  });
  productQuantityInput?.addEventListener("change", () => {
    selectedProductQuantity({ commit: true });
    updateProductPurchase();
  });
  productQuantityMinus?.addEventListener("click", () => adjustProductQuantity(-1));
  productQuantityPlus?.addEventListener("click", () => adjustProductQuantity(1));
  productForm?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const variant = selectedVariantData();
    if (!variant?.available) return;
    if (!validateLogoSelection()) return;
    const quantity = selectedProductQuantity({ commit: true });
    const items = [{ id: variant.id, quantity }];
    let selectedCaps = null;
    if (capControl?.checked) {
      selectedCaps = selectedQuickCapVariant(productCapPicker);
      if (!selectedCaps) return;
      items.push({ id: selectedCaps.id, quantity: 1 });
    }
    primaryProductButton.disabled = true;
    try {
      if (logoToggle?.checked) {
        await addProductWithLogo({
          variant,
          quantity,
          selectedCaps,
          source: productPage.querySelector("[data-vl-product-image]"),
          image: primaryProductButton.dataset.vlAddImage || variant.image,
        });
      } else {
        await addItems(
          items,
          productPage.querySelector("[data-vl-product-image]"),
          primaryProductButton.dataset.vlAddImage || variant.image,
        );
      }
    } catch (error) {
      window.alert(error.message);
    } finally {
      primaryProductButton.disabled = false;
    }
  });
  productPage?.querySelector("[data-vl-sticky-submit]")?.addEventListener("click", () => primaryProductButton?.click());

  if (primaryProductButton && "IntersectionObserver" in window) {
    const sticky = productPage.querySelector("[data-vl-sticky-cart]");
    const observer = new IntersectionObserver(([entry]) => {
      sticky?.classList.toggle("show", !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, { threshold: 0.1 });
    observer.observe(primaryProductButton);
  }
  updateProductPurchase();

  async function changeCartLine(key, quantity) {
    const cart = await fetchCart();
    await updateCartLines(updatesForCartLine(cart, key, quantity));
    window.location.reload();
  }

  document.querySelectorAll("[data-vl-cart-page-quantity]").forEach((button) => {
    button.addEventListener("click", async () => {
      const current = Number(button.parentElement?.querySelector("span")?.textContent || 1);
      const next = Math.max(0, current + Number(button.dataset.delta || 0));
      button.disabled = true;
      try {
        await changeCartLine(button.dataset.vlCartPageQuantity, next);
      } catch (error) {
        window.alert(error.message);
        button.disabled = false;
      }
    });
  });

  document.querySelectorAll("[data-vl-cart-page-remove]").forEach((button) => {
    button.addEventListener("click", async () => {
      button.disabled = true;
      try {
        await changeCartLine(button.dataset.vlCartPageRemove, 0);
      } catch (error) {
        window.alert(error.message);
        button.disabled = false;
      }
    });
  });

  document.querySelector("[data-vl-cart-page-add]")?.addEventListener("click", async (event) => {
    const button = event.currentTarget;
    const cartPageCapPicker = button.closest("[data-vl-cart-page-cap-offer]")?.querySelector("[data-vl-cap-option-picker]");
    const selectedCaps = selectedQuickCapVariant(cartPageCapPicker);
    if (!selectedCaps) return;
    button.dataset.vlCartPageAdd = String(selectedCaps.id);
    button.disabled = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.vlCartPageAdd), quantity: 1 }] }),
      });
      if (!response.ok) throw new Error("Compatible caps could not be added.");
      document.dispatchEvent(new CustomEvent("vl:cart:add", {
        detail: { items: [{ id: Number(button.dataset.vlCartPageAdd), quantity: 1 }] },
      }));
      window.location.reload();
    } catch (error) {
      window.alert(error.message);
      button.disabled = false;
    }
  });

  const discountInput = document.querySelector("[data-vl-cart-discount]");
  const discountButton = document.querySelector("[data-vl-cart-discount-apply]");
  discountInput?.addEventListener("input", () => {
    discountButton.disabled = !discountInput.value.trim();
  });
  discountButton?.addEventListener("click", () => {
    const code = discountInput.value.trim();
    if (!code) return;
    window.location.assign(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent("/cart")}`);
  });

})();
